import React from 'react'
import styled from 'styled-components'
import { FormError, DeliveryAutosuggest } from '../../../..'
import {
  useAddressForm,
  UseCheckoutEcontAddressResults,
  UseCheckoutSpeedyAddressResults,
  UseCheckoutEvropatAddressResults,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { Input, InputLabel as Label } from '../../../../../Common'

const classNames = {
  city: 'col-12 col-sm-6',
  office: 'col-12 col-sm-6',
}

export const GenericOfficeForm = ({
  methods,
}: {
  methods:
    | UseCheckoutEcontAddressResults
    | UseCheckoutEvropatAddressResults
    | UseCheckoutSpeedyAddressResults
}) => {
  const methodNames = Object.keys(methods || {})
  const { address } = useGlobalLabels()
  const fieldsLabel = {
    city: address?.city,
    office: address?.office,
  }

  const {
    setModuleAddressData,
    moduleData,
    errors,
    onInputChange,
    addressState,
  } = useAddressForm()

  const selectedCity = moduleData?.moduleData?.address?.city

  const selectedMap = {
    city: selectedCity,
    office: moduleData?.moduleData?.address?.office,
  }

  const disabledMap = {
    office: !selectedCity,
  }

  const parentsMap = {
    office: selectedCity?.id,
  }

  const minLengthMap = {
    office: 0,
  }

  const removeMap = {
    city: () => {
      setModuleAddressData('city', undefined)
      setModuleAddressData('street', undefined)
      setModuleAddressData('quarter', undefined)
      setModuleAddressData('office', undefined)
    },
    office: () => {
      setModuleAddressData('office', undefined)
    },
  }

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onInputChange?.(e.target.name, e.target.value)
  }

  return (
    <div>
      <InputsWrapper>
        {methodNames.map((name, index) => {
          const method = methods[name]
          const label = fieldsLabel[name]

          if (!label) return null

          return (
            <div
              className={classNames[name]}
              key={`${method}-${name}-${index}`}
            >
              <DeliveryAutosuggest
                getItems={method.get}
                setItem={(value: any) => setModuleAddressData(name, value)}
                label={label}
                items={method.currentResults}
                remove={removeMap[name]}
                selected={selectedMap[name]}
                disabled={disabledMap[name]}
                parent={parentsMap[name]}
                minLength={minLengthMap[name]}
              />
              <FormError errors={errors} fieldName={name} />
            </div>
          )
        })}
        <div className="col-12">
          <Label htmlFor="adbook-additionalAddressInfo">
            {address?.additionalInformation}
            <Input
              value={addressState?.additionalAddressInfo}
              name="additionalAddressInfo"
              id="adbook-additionalAddressInfo"
              onChange={onChange}
            />
            <FormError errors={errors} fieldName="additionalAddressInfo" />
          </Label>
        </div>
      </InputsWrapper>
    </div>
  )
}

const InputsWrapper = styled.div.attrs({
  className: 'row',
})``
